type WidthListener = (width: number) => void;

/**
 * Subscribes to window resize and publishes width at most once per animation
 * frame, skipping unchanged values. Returns an unsubscribe that removes the
 * listener and cancels a pending frame.
 */
export const subscribeWindowWidth = (
  onWidth: WidthListener,
  getWidth: () => number = () => window.innerWidth,
): (() => void) => {
  let frameId = 0;
  let lastWidth: number | null = null;

  const publish = () => {
    frameId = 0;
    const width = getWidth();
    if (width === lastWidth) {
      return;
    }
    lastWidth = width;
    onWidth(width);
  };

  const onResize = () => {
    if (frameId) {
      return;
    }
    frameId = window.requestAnimationFrame(publish);
  };

  window.addEventListener('resize', onResize);

  return () => {
    if (frameId) {
      window.cancelAnimationFrame(frameId);
      frameId = 0;
    }
    window.removeEventListener('resize', onResize);
  };
};
